import React from "react";
import { urlifyName } from "../../../shared/Utils/PageUrl";
import { Link } from "react-router-dom";
import { extractTextContent } from "../../../shared/Utils/ExtractText";
import { blogCardTitleExcerpt } from "../../../shared/Utils/CardTitleExcerpt";

function BlogCard({
  title,
  subtitle,
  created_at,
  paragraph_1,
  image_1,
  paragraph_2,
  paragraph_3,
  paragraph_4,
  paragraph_5,
  paragraph_6,
  paragraph_7,
  paragraph_8,
  paragraph_9,
  paragraph_10,
}) {
  const createExcerpt = (htmlContent) => {
    const plainText = htmlContent.replace(/<[^>]+>/g, "");
    let excerptLength = 60; // Always set length to 50 characters
    let excerpt = plainText.substring(0, excerptLength);

    // Check if we are in the middle of a word and cut to the end of the word if so
    if (
      plainText.length > excerptLength &&
      plainText.charAt(excerptLength) !== " "
    ) {
      let endOfWordIndex = plainText.indexOf(" ", excerptLength);
      excerpt =
        endOfWordIndex === -1
          ? excerpt
          : plainText.substring(0, endOfWordIndex);
    }

    // Ensure the last character isn't punctuation before adding ellipsis
    excerpt = excerpt.replace(/[.,;!?]$/, "") + "...";

    return excerpt;
  };

  const calculateReadingTime = (text) => {
    const wordsPerMinute = 225;
    const words = text.replace(/<[^>]+>/g, "").split(/\s+/).length;
    const minutes = words / wordsPerMinute;
    return Math.ceil(minutes);
  };

  const totalReadingTime = calculateReadingTime(
    paragraph_1 +
      paragraph_2 +
      paragraph_3 +
      paragraph_4 +
      paragraph_5 +
      paragraph_6 +
      paragraph_7 +
      paragraph_8 +
      paragraph_9 +
      paragraph_10
  );

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Link to={`/blogs/${urlifyName(title)}`} onClick={handleClick}>
      <div
        className="bg-white shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
        style={{ borderRadius: "20px", width: "300px", height: "320px" }}
      >
        {/* Image */}
        <div className="h-[180px] overflow-hidden">
          <img
            src={image_1}
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Content */}
        <div className="px-4 pb-4 pt-2">
          {/* Date and Reading Time */}
          <p className="!text-xs !font-montserrat text-left !font-normal  ">
            {new Date(created_at)
              .toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
              })
              .toUpperCase()}{" "}
            | {totalReadingTime} MIN READ
          </p>

          {/* Title */}
          <h3 className="!text-sm !font-montserrat text-left !font-bold text-blue mb-1 leading-tight">
            {blogCardTitleExcerpt(title, 50)}
          </h3>

          {/* Description */}
          <p className="!text-xs !font-montserrat text-left !font-normal break-words leading-relaxed">
            {subtitle}
          </p>
        </div>
      </div>
    </Link>
  );
}

export default BlogCard;
